import axios from "axios"
import store from '../store';
import router from '../router'

axios.defaults.baseURL = process.env.API_ROOT;	


// 添加请求拦截器
// 请求添加 config参数 noLoading(boolean值)控制全局loading
axios.interceptors.request.use(function (config) {
    config.headers["token"] = store.state.user.token||'';
	if(!config.noLoading){
		store.commit('req',true)
	}
	// 在发送请求之前做些什么
    return config;
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
});

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
	store.commit('req',false)
	
    // 当响应数据为为token失效，则重新登录
    if(response.data.code==(401)){
    	store.commit("Logout");
        location.reload()
        return;
    }
    return response;
 }, function (error) {
  store.commit('req',false)
  return Promise.reject(error);
});
export default axios


// WEBPACK FOOTER //
// ./src/utils/http.js